import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, contains } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedDescripcionPaquete } from "./types";

/**Determina si una descripción de paquete esta seleccionada */
function estaSeleccionada(item: models.DescripcionPaqueteDTO, selected: number[]): boolean {
    return contains(selected, item.IdRegistro);
}

/**Obtiene un conjunto de descripción de paquetes a un conjunto de SelectedDescripcionPaquete */
export function toSelected(items: models.DescripcionPaqueteDTO[], selected: number[]): SelectedDescripcionPaquete[] {
    const ret = items.map(x => ({ ...x, Selected: estaSeleccionada(x, selected) }));
    return ret;
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/descripcionpaquetes/logic.tsx